import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import autobind from 'react-autobind'
import Dialog from '../Dialog/Dialog';

export default class MerchantListItem extends Component {
  constructor(props) {
    super(props)
    autobind(this)
    this.state = {
      impersonateTooltipOpen: false,
      deleteUserTooltipOpen: false,
      blockedUserTooltipOpen: false,
      deleteDialogOpen: false
    }
  }


  toggleImpersonateTooltipOpen() {
    this.setState({
      impersonateTooltipOpen: !this.state.impersonateTooltipOpen
    })
  }

  toggleBlockedUserTooltipOpen() {
    this.setState({
      blockedUserTooltipOpen: !this.state.blockedUserTooltipOpen
    })
  }

  toggleDeleteUserTooltipOpen() {
    this.setState({
      deleteUserTooltipOpen: !this.state.deleteUserTooltipOpen
    })
  }

  renderUnblockButton(merchant) {
    if (merchant.blocked) {
      return <span>
        <span id={`unblock${merchant._id}`} className="ar-icon s7-lock" onClick={() => this.props.unblock(merchant._id)}></span>
        <Tooltip placement="top" isOpen={this.state.blockedUserTooltipOpen} target={`unblock${merchant._id}`} toggle={this.toggleBlockedUserTooltipOpen}>
          This user is blocked due to maximum number of failed conversions.<br />Click to unblock the user
            </Tooltip>
      </span>
    }
  }

  renderImpersonateUserButton(merchant) {
    const tooltipText = merchant.subscriptionSettings.length ? "Impersonate this user" : <span> This user has no subscriptions<br /> Cannot impersonate</span>

    return <span>
      <span
        id={`impersonateTooltip${merchant._id}`}
        className={`ar-icon s7-user ${!merchant.subscriptionSettings.length ? 'disabled' : ''}`}
        onClick={() => { if (merchant.subscriptionSettings.length > 0) this.props.impersonate(merchant._id) }}
      >
      </span>
      <Tooltip
        placement="top"
        isOpen={this.state.impersonateTooltipOpen}
        target={`impersonateTooltip${merchant._id}`}
        toggle={this.toggleImpersonateTooltipOpen}
      >
        {tooltipText}
      </Tooltip>

    </span>
  }

  renderDeleteUserButton(merchant) {

    return <span>
      <span
        id={`deleteTooltip${merchant._id}`}
        className="ar-icon s7-trash"
        onClick={this.openDeleteDialog}
      >
      </span>
      <Tooltip
        placement="top"
        isOpen={this.state.deleteUserTooltipOpen}
        target={`deleteTooltip${merchant._id}`}
        toggle={this.toggleDeleteUserTooltipOpen}
      >
        Delete this user
      </Tooltip>
    </span>
  }

  openDeleteDialog = () => {
    this.setState({
      deleteDialogOpen: true
    })
  }

  closeDeleteDialog = () => {
    this.setState({
      deleteDialogOpen: false
    })
  }

  confirmDeleteDialogAction = (merchant) => {
    this.props.onDelete(merchant._id);
    this.closeDeleteDialog();
  }

  render() {

    const { merchant } = this.props;

    return (
      <div className="items-list-item items-list-item--merchants align-items-stretch">
        <div className="list-item-1 flex-column justify-content-center align-items-start">
          <div className="product-details">
            <span className="name break-all"><b>{merchant.username}</b></span>
          </div>
          <div className="product-details">
            <span className="name break-all"><b>{merchant.email}</b></span>
          </div>
        </div>
        <div className="list-item-2 flex-column justify-content-center align-items-start">
          <div>Storage:<div> {merchant.metrics.storage_used.toFixed(2)} / {merchant.metrics.storage_available.toFixed(2)} MB</div></div>
          <div>Traffic:<div> {merchant.metrics.traffic_used.toFixed(2)} / {merchant.metrics.traffic_available.toFixed(2)} MB</div></div>
        </div>
        <div className="list-item-3 flex-column justify-content-center align-items-start">
          <div className="break-all">
            {merchant.contactPersons ? merchant.contactPersons.name : ''}
          </div>
          <div className="break-all">
            {merchant.contactPersons ? merchant.contactPersons.email : ''}
          </div>
          <div className="break-all">
            {merchant.contactPersons ? merchant.contactPersons.phoneNumber : ''}
          </div>
        </div>
        <div className="list-item-4 flex-column justify-content-center align-items-start">
          <div>
            {merchant.paymentDetails ? merchant.paymentDetails.CUI : ''}
          </div>
          <div>
            {merchant.paymentDetails ? merchant.paymentDetails.accountNumber : ''}
          </div>
          <div>
            {merchant.paymentDetails ? merchant.paymentDetails.companyName : ''}
          </div>
        </div>
        <div className="list-item-5 list-item-actions">
          {this.renderImpersonateUserButton(merchant)}
          {this.renderDeleteUserButton(merchant)}
          {this.renderUnblockButton(merchant)}
        </div>
        <Dialog
          open={this.state.deleteDialogOpen}
          proceed={() => this.confirmDeleteDialogAction(merchant)}
          cancel = {this.closeDeleteDialog}
          message="If you delete this user you won't be able to retrieve the data."        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Merchant/MerchantListItem.js